@if (!pageIsLoaded) {
  <div class="loader_div">
    <i-loader [size]="100" [text]="'loading' | translate"></i-loader>
  </div>
}
<div [ngClass]="{ noVisibility: !pageIsLoaded }">
  <form [formGroup]="form" class="mb-3 row">
    @if (displayWarningChildServiceDetected) {
      <div class="col-12 alert alert-info">{{ 'iScan.information.otherDataAvailable' | translate }}</div>
    }
    <div class="col-md-6 mb-3 p-fluid">
      <label class="w-100" for="p-treeSelect-simple-mail-creation-modal">
        <span class="super-compos-label-input">{{ 'global.service' | translate }}*</span>
        <p-treeSelect
          id="p-treeSelect-simple-mail-creation-modal"
          [emptyMessage]="'noResultFound' | translate"
          [options]="showAllServices ? services : servicesOnlyParent"
          #treeSelect
          class="treeSelect"
          selectionMode="single"
          (onShow)="onShowTreeSelect()"
          [placeholder]="'pleaseSelectAService' | translate"
          appendTo="body"
          (onNodeSelect)="select($event)"
          [filter]="true"
          [filterPlaceholder]="'global.filterPlaceholder' | translate"
          [filterBy]="'label'"
          [filterMode]="'strict'"
          [metaKeySelection]="false"></p-treeSelect
      ></label>
    </div>
    <div class="col-md-6 mb-3 p-fluid">
      <label class="w-100">
        <span [ngClass]="{ disabledLabel: !scanningCenters?.length }" class="super-compos-label-input">{{
          'iScan.globalInfos.scanningCenter' | translate
        }}</span>
        <p-dropdown
          [disabled]="!scanningCenters?.length"
          styleClass="w-100"
          [virtualScroll]="true"
          virtualScrollItemSize="30"
          appendTo="body"
          [options]="scanningCenters | sort: 'label' : 'ASC'"
          [filter]="true"
          [placeholder]="checkIfSomeScanningCenterExist()"
          [showClear]="true"
          formControlName="CentreNumKey">
        </p-dropdown
      ></label>
    </div>

    <div class="col-md-6 mb-3">
      <label class="w-100">
        <span [ngClass]="{ disabledLabel: !natures?.length }" class="super-compos-label-input">{{ 'global.nature' | translate }}</span>
        <p-dropdown
          [disabled]="!natures?.length"
          styleClass="w-100"
          [virtualScroll]="true"
          virtualScrollItemSize="30"
          appendTo="body"
          [options]="natures | sort: 'label' : 'ASC'"
          [filter]="true"
          [placeholder]="checkIfSomeNatureExist()"
          [showClear]="true"
          formControlName="NatureId">
        </p-dropdown
      ></label>
    </div>

    <div class="col-md-6 mb-3">
      <label class="w-100">
        <span [ngClass]="{ disabledLabel: !sources?.length }" class="super-compos-label-input">{{ 'global.source' | translate }}</span>
        <p-dropdown
          [disabled]="!sources?.length"
          styleClass="w-100"
          [virtualScroll]="true"
          (onChange)="changeSource($event)"
          virtualScrollItemSize="30"
          appendTo="body"
          [options]="sources | sort: 'label' : 'ASC'"
          [filter]="true"
          [placeholder]="checkIfSomeSourceExist()"
          [showClear]="true"
          formControlName="SourceId">
        </p-dropdown
      ></label>
    </div>

    @if (showRecommendedReference) {
      <div class="col-md-12 mb-3">
        <label class="w-100">
          <span class="super-compos-label-input">{{ 'global.recommendedRef' | translate }}</span>
          <i-input
            [type]="'text'"
            [iInput]="{ placeholder: 'global.recommendedRef' | translate }"
            [control]="form.get('ReferenceRecommande')"
            [showError]="false"
            styleClass="d-block w-100"></i-input>
        </label>
      </div>
    }

    <div class="col-md-6 mb-3 p-fluid">
      <label class="w-100">
        <span [ngClass]="{ disabledLabel: !recipients?.length }" class="super-compos-label-input">{{ 'global.recipients' | translate }} </span>
        <p-dropdown
          [disabled]="!recipients?.length"
          styleClass="w-100"
          [virtualScroll]="true"
          optionLabel="name"
          optionValue="contactForUser.contactId"
          virtualScrollItemSize="30"
          appendTo="body"
          [options]="recipients | sort: 'label' : 'ASC'"
          [filter]="true"
          [placeholder]="checkIfSomeRecipientExist()"
          [showClear]="true"
          formControlName="DestinataireContactId">
        </p-dropdown
      ></label>
    </div>

    <div class="col-md-6 mb-3 p-fluid">
      <label class="w-100">
        <span [ngClass]="{ disabledLabel: !classificationCodes?.length }" class="super-compos-label-input"
          >{{ 'global.classificationsCodes' | translate }}
        </span>
        <p-dropdown
          [disabled]="!classificationCodes?.length"
          styleClass="w-100"
          [virtualScroll]="true"
          virtualScrollItemSize="30"
          appendTo="body"
          [options]="classificationCodes | sort: 'label' : 'ASC'"
          [filter]="true"
          [placeholder]="checkIfSomeClassificationCodeExist()"
          [showClear]="true"
          formControlName="ClassementId">
        </p-dropdown
      ></label>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-6 mb-3">
      <label class="w-100">
        <span class="super-compos-label-input">{{ 'global.entryDate' | translate }}*</span>
        <p-calendar
          [firstDayOfWeek]="1"
          appendTo="body"
          formControlName="DateEntree"
          [showIcon]="true"
          [iconDisplay]="'input'"
          dateFormat="dd/mm/yy"
          [maxDate]="maxDate"
          (onSelect)="changeMaxDateDocumentsClick($event)"
          (onInput)="changeMaxDateDocuments($event)">
        </p-calendar>
      </label>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-6 mb-3">
      <label class="w-100">
        <span class="super-compos-label-input">{{ 'global.documentDate' | translate }}</span>
        <i-input
          [type]="'calendar'"
          [iInput]="{ options: { maxDate: maxDateModified, dateFormat: 'dd/mm/yy' } }"
          [control]="form.get('DateDocument')">
        </i-input>
      </label>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-6 mb-3">
      <label class="w-100">
        <span class="super-compos-label-input">{{ 'global.dueDate' | translate }}</span>
        <i-input [type]="'calendar'" [iInput]="{ options: { dateFormat: 'dd/mm/yy' } }" [control]="form.get('DateEcheance')"> </i-input>
      </label>
    </div>

    <div class="col-lg-3 col-md-6 col-sm-6 mb-3">
      <label class="w-100">
        <span class="super-compos-label-input">{{ 'global.postalDate' | translate }}</span>
        <i-input [type]="'calendar'" [iInput]="{ options: { maxDate: maxDateModified, dateFormat: 'dd/mm/yy' } }" [control]="form.get('DatePostale')">
        </i-input>
      </label>
    </div>
    <div class="col-md-12 mb-3">
      <label class="w-100">
        <span class="super-compos-label-input">{{ 'global.remarks' | translate }}</span>
        <textarea
          rows="5"
          cols="30"
          [placeholder]="'iScan.action.insertYourRemark' | translate"
          formControlName="Remarques"
          class="super-compos-input-text form-control w-100"
          pInputTextarea></textarea>
      </label>
    </div>
  </form>
</div>
<div class="modal-scss">
  <i-button styleClass="bottomButton red mb-3" (click)="emitCloseModal()" [text]="'cancel' | translate"></i-button>
  <i-button styleClass="bottomButton green" [disabled]="!form.valid" (click)="createFromScan()" [text]="'confirm' | translate"></i-button>
</div>
